import { Mail, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Contact() {
  return (
    <div className="pt-16 md:pt-20" data-testid="page-contact">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-40">
        <div className="text-xs uppercase tracking-[0.3em] text-forest font-semibold mb-6">Contact</div>
        <h1 className="text-5xl sm:text-6xl lg:text-8xl font-extrabold text-navy tracking-tighter leading-[0.95] max-w-4xl">
          Say hello.
        </h1>
        <p className="mt-8 text-lg md:text-xl text-slate max-w-2xl leading-relaxed">
          One email — every industry we operate in.
        </p>

        <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center gap-6">
          <a
            href="mailto:info@stoneshire.ca"
            className="inline-flex items-center gap-4 rounded-2xl bg-navy text-white px-8 py-6 hover:bg-forest transition-colors"
            data-testid="contact-email"
          >
            <Mail size={22}/>
            <span className="text-2xl md:text-3xl font-bold tracking-tight">info@stoneshire.ca</span>
          </a>
          <Link to="/partner" className="inline-flex items-center gap-2 text-navy font-semibold hover:text-forest transition-colors" data-testid="contact-cta-partner">
            Or use the intake form <ArrowRight size={16}/>
          </Link>
        </div>
      </section>
    </div>
  );
}
